import { useDispatch, useSelector } from 'react-redux';
import React, { useCallback, useEffect } from 'react';
import {
    setAllPermisosDE,
    setCrearDE,
    setDescargarKude,
    setDescargarXML,
    setEditarDE,
    setEnviarCorreoDE,
    setEventoCancelacionDE,
    setEventoConformidadDE,
    setEventoDesconocimientoDE,
    setEventoDisconformidadDE,
    setEventoInutilizacionDE,
    setEventoNominacionDE,
    setEventoRecepcionDE,
    setListarDE,
    setVerDetalleDE,
    setVerEventosCorreoDE,
    setVisorXML
} from '../reducer';
import { useUpdateEffect } from 'primereact/hooks';
import { isEmpty } from 'lodash';
import {
    ALL_PERMISOS_DE,
    CREAR_DE,
    DESCARGAR_KUDE_DE,
    DESCARGAR_XML,
    EDITAR_DE,
    ENVIAR_CORREO_DE,
    EVENTO_CANCELACION_DE,
    EVENTO_CONFORMIDAD_DE,
    EVENTO_DESCONOCIMIENTO_DE,
    EVENTO_DISCONFORMIDAD_DE,
    EVENTO_INUTILIZACION_DE,
    EVENTO_NOMINACION_DE,
    EVENTO_RECEPCION_DE,
    findPermission,
    LISTAR_DE,
    VER_DETALLE_DE,
    VER_EVENTOS_CORREOS_DE,
    VISOR_XML
} from '../../../../utilities/permission';
import { Checkbox } from 'primereact/checkbox';

const DEPermiso = () => {
    const asignaciones = useSelector((state) => state.usuario.asignaciones);
    const emisorSeleccionado = useSelector((state) => state.usuario.emisorSeleccionado);

    const {
        allPermisosDE,
        listarDE,
        verDetalleDE,
        crearDE,
        editarDE,
        eventoNominacionDE,
        eventoRecepcionDE,
        eventoConformidadDE,
        eventoDisconformidadDE,
        eventoInutilizacionDE,
        eventoDesconocimientoDE,
        eventoCancelacionDE,
        descargarKude,
        descargarXML,
        visorXML,
        enviarCorreoDE,
        verEventosCorreoDE
    } = useSelector((state) => state.usuario);

    const dispatch = useDispatch();

    const flipFeatures = useCallback(
        (flag) => {
            dispatch(setAllPermisosDE(flag));
            dispatch(setListarDE(flag));
            dispatch(setVerDetalleDE(flag));
            dispatch(setEditarDE(flag));
            dispatch(setCrearDE(flag));
            dispatch(setEventoNominacionDE(flag));
            dispatch(setEventoRecepcionDE(flag));
            dispatch(setEventoConformidadDE(flag));
            dispatch(setEventoDisconformidadDE(flag));
            dispatch(setEventoDesconocimientoDE(flag));
            dispatch(setEventoInutilizacionDE(flag));
            dispatch(setEventoCancelacionDE(flag));
            dispatch(setDescargarKude(flag));
            dispatch(setDescargarXML(flag));
            dispatch(setVisorXML(flag));
            dispatch(setEnviarCorreoDE(flag));
            dispatch(setVerEventosCorreoDE(flag));
        },
        [dispatch]
    );

    useUpdateEffect(() => {
        if (allPermisosDE) {
            flipFeatures(true);
            return;
        }

        flipFeatures(false);
    }, [allPermisosDE]);

    useEffect(() => {
        if (isEmpty(asignaciones) || isEmpty(emisorSeleccionado)) {
            flipFeatures(false);
            return;
        }

        const asignacion = asignaciones[emisorSeleccionado.ruc];
        if (isEmpty(asignacion?.permisos)) {
            flipFeatures(false);
            return;
        }

        //set everything back to false,
        flipFeatures(false);

        //If all is assigned, then we have nothing else to check
        if (findPermission(ALL_PERMISOS_DE, asignacion.permisos) > -1) {
            flipFeatures(true);
            return;
        }

        if (findPermission(LISTAR_DE, asignacion.permisos) > -1) {
            dispatch(setListarDE(true));
        }

        if (findPermission(VER_DETALLE_DE, asignacion.permisos) > -1) {
            dispatch(setVerDetalleDE(true));
        }

        if (findPermission(CREAR_DE, asignacion.permisos) > -1) {
            dispatch(setCrearDE(true));
        }

        if (findPermission(EDITAR_DE, asignacion.permisos) > -1) {
            dispatch(setEditarDE(true));
        }

        if (findPermission(EVENTO_NOMINACION_DE, asignacion.permisos) > -1) {
            dispatch(setEventoNominacionDE(true));
        }

        if (findPermission(EVENTO_RECEPCION_DE, asignacion.permisos) > -1) {
            dispatch(setEventoRecepcionDE(true));
        }

        if (findPermission(EVENTO_CONFORMIDAD_DE, asignacion.permisos) > -1) {
            dispatch(setEventoConformidadDE(true));
        }

        if (findPermission(EVENTO_DISCONFORMIDAD_DE, asignacion.permisos) > -1) {
            dispatch(setEventoDisconformidadDE(true));
        }

        if (findPermission(EVENTO_DESCONOCIMIENTO_DE, asignacion.permisos) > -1) {
            dispatch(setEventoDesconocimientoDE(true));
        }

        if (findPermission(EVENTO_INUTILIZACION_DE, asignacion.permisos) > -1) {
            dispatch(setEventoInutilizacionDE(true));
        }

        if (findPermission(EVENTO_CANCELACION_DE, asignacion.permisos) > -1) {
            dispatch(setEventoCancelacionDE(true));
        }

        if (findPermission(DESCARGAR_KUDE_DE, asignacion.permisos) > -1) {
            dispatch(setDescargarKude(true));
        }

        if (findPermission(DESCARGAR_XML, asignacion.permisos) > -1) {
            dispatch(setDescargarXML(true));
        }

        if (findPermission(VISOR_XML, asignacion.permisos) > -1) {
            dispatch(setVisorXML(true));
        }

        if (findPermission(ENVIAR_CORREO_DE, asignacion.permisos) > -1) {
            dispatch(setEnviarCorreoDE(true));
        }

        if (findPermission(VER_EVENTOS_CORREOS_DE, asignacion.permisos) > -1) {
            dispatch(setVerEventosCorreoDE(true));
        }
    }, [asignaciones, emisorSeleccionado, dispatch, flipFeatures]);

    return (
        <div className="flex flex-wrap justify-content-center align-items-center gap-3">
            <div className="flex align-items-center">
                <Checkbox
                    inputId="allPermisosDE"
                    onChange={(e) => {
                        dispatch(setAllPermisosDE(e.target.checked));
                    }}
                    checked={allPermisosDE}
                />
                <label htmlFor="allPermisosDE" className="ml-2">
                    Todos
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="listarDE"
                    onChange={(e) => {
                        dispatch(setListarDE(e.target.checked));
                    }}
                    checked={listarDE}
                />
                <label htmlFor="listarDE" className="ml-2">
                    Listar
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="verDetalleDE"
                    onChange={(e) => {
                        dispatch(setVerDetalleDE(e.target.checked));
                    }}
                    checked={verDetalleDE}
                />
                <label htmlFor="verDetalleDE" className="ml-2">
                    Ver detalle
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="crearDE"
                    onChange={(e) => {
                        dispatch(setCrearDE(e.target.checked));
                    }}
                    checked={crearDE}
                />
                <label htmlFor="crearDE" className="ml-2">
                    Crear
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="editarDE"
                    onChange={(e) => {
                        dispatch(setEditarDE(e.target.checked));
                    }}
                    checked={editarDE}
                />
                <label htmlFor="editarDE" className="ml-2">
                    Editar
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="eventoNominacionDE"
                    onChange={(e) => {
                        dispatch(setEventoNominacionDE(e.target.checked));
                    }}
                    checked={eventoNominacionDE}
                />
                <label htmlFor="eventoNominacionDE" className="ml-2">
                    Evento de nominación
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="eventoRecepcionDE"
                    onChange={(e) => {
                        dispatch(setEventoRecepcionDE(e.target.checked));
                    }}
                    checked={eventoRecepcionDE}
                />
                <label htmlFor="eventoRecepcionDE" className="ml-2">
                    Evento de recepción
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="eventoConformidadDE"
                    onChange={(e) => {
                        dispatch(setEventoConformidadDE(e.target.checked));
                    }}
                    checked={eventoConformidadDE}
                />
                <label htmlFor="eventoConformidadDE" className="ml-2">
                    Evento de conformidad
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="eventoDisconformidadDE"
                    onChange={(e) => {
                        dispatch(setEventoDisconformidadDE(e.target.checked));
                    }}
                    checked={eventoDisconformidadDE}
                />
                <label htmlFor="eventoDisconformidadDE" className="ml-2">
                    Evento de disconformidad
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="eventoDesconocimientoDE"
                    onChange={(e) => {
                        dispatch(setEventoDesconocimientoDE(e.target.checked));
                    }}
                    checked={eventoDesconocimientoDE}
                />
                <label htmlFor="eventoDesconocimientoDE" className="ml-2">
                    Evento de desconocimiento
                </label>
            </div>

            <div className="flex align-items-center">
                <Checkbox
                    inputId="eventoInutilizacionDE"
                    onChange={(e) => {
                        dispatch(setEventoInutilizacionDE(e.target.checked));
                    }}
                    checked={eventoInutilizacionDE}
                />
                <label htmlFor="eventoInutilizacionDE" className="ml-2">
                    Evento de inutilización
                </label>
            </div>

            <div className="flex align-items-center">
                <Checkbox
                    inputId="eventoCancelacionDE"
                    onChange={(e) => {
                        dispatch(setEventoCancelacionDE(e.target.checked));
                    }}
                    checked={eventoCancelacionDE}
                />
                <label htmlFor="eventoCancelacionDE" className="ml-2">
                    Evento de cancelación
                </label>
            </div>

            <div className="flex align-items-center">
                <Checkbox
                    inputId="descargarKuDE"
                    onChange={(e) => {
                        dispatch(setDescargarKude(e.target.checked));
                    }}
                    checked={descargarKude}
                />
                <label htmlFor="descargarKuDE" className="ml-2">
                    Descargar KuDE
                </label>
            </div>

            <div className="flex align-items-center">
                <Checkbox
                    inputId="descargarXML"
                    onChange={(e) => {
                        dispatch(setDescargarXML(e.target.checked));
                    }}
                    checked={descargarXML}
                />
                <label htmlFor="descargarXML" className="ml-2">
                    Descargar XML
                </label>
            </div>

            <div className="flex align-items-center">
                <Checkbox
                    inputId="visorXML"
                    onChange={(e) => {
                        dispatch(setVisorXML(e.target.checked));
                    }}
                    checked={visorXML}
                />
                <label htmlFor="visorXML" className="ml-2">
                    Visor XML
                </label>
            </div>

            <div className="flex align-items-center">
                <Checkbox
                    inputId="enviarCorreoDE"
                    onChange={(e) => {
                        dispatch(setEnviarCorreoDE(e.target.checked));
                    }}
                    checked={enviarCorreoDE}
                />
                <label htmlFor="enviarCorreoDE" className="ml-2">
                    Enviar correo
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="verEventosCorreosDE"
                    onChange={(e) => {
                        dispatch(setVerEventosCorreoDE(e.target.checked));
                    }}
                    checked={verEventosCorreoDE}
                />
                <label htmlFor="verEventosCorreosDE" className="ml-2">
                    Eventos de correos
                </label>
            </div>
        </div>
    );
};

export default DEPermiso;
